import { ref } from 'vue';

// Any link to this reopens the cookie banner so visitors can change their choice.
export const COOKIE_SETTINGS_HASH = '#cookie-settings';

// The banner is only on pages that need consent, and only it can handle the
// link, so links to it should only show while it is mounted.
export const cookieBannerMounted = ref(false);
